<template>
  <section class="rusd-section">
    <h2 class="section-title">
      <span class="line1">质押RAD与BOX即可获得</span>
      <span class="line2">RUSD奖励</span>
    </h2>
    <p class="description">
      通过RAD质押生态，最高享182.5%的年化收益。<br>
      多层次的团队的奖励，推广越多收益越高。<br>
      去中心化运行，安全可靠。<br>
    </p>

    <ul class="feature-list">
      <li v-for="(item, index) in features" :key="index">
        <img src="@/assets/image/radio_select.png" alt class="dot" />
        <span>{{ item }}</span>
      </li>
    </ul>

    <router-link to="/pledge" class="submit-btn">立即参与</router-link>

    <AnimatedSvgIllustration
      :src="svg2Url"
      uid="rusd-svg2"
      class="bottom-illustration"
    />
  </section>
</template>

<script>
import { RUSD_FEATURES } from "../config";
import AnimatedSvgIllustration from "./AnimatedSvgIllustration.vue";
import svg2Url from "@/assets/image/svg2.svg";

export default {
  components: {
    AnimatedSvgIllustration,
  },
  data() {
    return {
      features: RUSD_FEATURES,
      svg2Url,
    };
  },
};
</script>

<style lang="scss" scoped>
.rusd-section {
  padding: 50px 30px 30px;
}

.section-title {
  display: flex;
  flex-direction: column;
  margin: 30px 0 30px;
  font-weight: normal;
  font-size: 50px;

  .line1 {
    color: #fff;
  }

  .line2 {
    display: flex;
    align-items: center;
    color: #7338ff;
  }

  .rusd-icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
}

.description {
  margin: 0 0 30px;
  font-size: 30px;
  line-height: 1.2;
  color: #c0c0c0;
}

.feature-list {
  margin: 0 0 36px;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 20px;
    font-size: 30px;
    line-height: 1.5;
    color: #fff;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .dot {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
}

.submit-btn {
  display: block;
  width: 100%;
  height: 88px;
  margin-bottom: 60px;
  margin-top: 60px;
  border: none;
  border-radius: 44px;
  font-size: 32px;
  line-height: 88px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  background: #7338ff;
  transition: opacity 0.2s;
  font-weight: bold;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
}

.bottom-illustration {
  display: block;
  width: 100%;
  margin-bottom: 0;
}
</style>
